import React from 'react';
import { SimpleGrid, SimpleGridProps, VStack } from '@chakra-ui/react';
import NavLink from './NavLink';
import { RiDashboardFill } from 'react-icons/ri';
import { ImPhone, ImUser } from 'react-icons/im';
import { BsChatFill } from 'react-icons/bs';

const PrimaryNav: React.FC = () => {
  return (
    <SimpleGrid as="nav" columns={{ base: 1, sm: 2, xl: 1 }} gap={2}>
      <NavLink
        label="Dashboard"
        icon={RiDashboardFill}
        to="/dashboard"
        highlightLocation
      />
      <NavLink label="Profile" icon={ImUser} to="/profile" highlightLocation />
      <NavLink
        label="Coaching Calls"
        icon={ImPhone}
        to="/sessions"
        highlightLocation
      />
      {/* <NavLink
        label="Session Reviews"
        icon={BsChatFill}
        to="/session-reviews"
        highlightLocation
      /> */}
    </SimpleGrid>
  );
};

export default PrimaryNav;
